module.exports = "//static.tradera.net/touchweb/static/output/images/push-splash.59e153a6.svg";